<template>
  <v-footer
    v-if="!isHide()"
    app
    class="hidden-sm-and-down"
    color="primary"
    dark
    height="80px"
    padless
  >
    <v-card
      color="primary"
      flat
      height="100%"
      tile
      width="100%"
    >
      <v-card-title class="pa-0 ma-0">
        <v-img
          :style="`width:100%;background-color:${accentColor}`"
          height="5px"
        />
        <v-img
          :style="`width:100%;background-color:${subPrimaryColor}`"
          height="2px"
        />
      </v-card-title>
      <v-card-actions class="pa-0">
        <v-img
          class="button-logo-img ml-3"
          contain
          max-height="74px"
          max-width="90px"
          src="../assets/logo_footer.png"
        />
        <div
          class="d-flex ma-0 pa-0"
          style="height: 100%;display: flex;justify-content: flex-end;flex-flow: column;"
        >
          <div class="ma-0 pa-0">
            <v-btn
              class="ma-0 pa-0 pr-3"
              small
              text
              to="/terms"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />
              利用規約
            </v-btn>
            <v-btn
              class="ma-0 pa-0 pr-3"
              small
              text
              to="/policy"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />
              プライバシーポリシー
            </v-btn>
            <v-btn
              class="ma-0 pa-0 pr-3"
              small
              text
              to="/tokushou"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />
              特定商取引法
            </v-btn>
            <v-btn
              class="ma-0 pa-0 pr-3"
              small
              text
              target="_blank"
              href="https://tayori.com/faq/e6b5fb46f996f88b9d57c5a98bb2f59e18e2ba05"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />
              ヘルプ
            </v-btn>
            <v-btn
              class="ma-0 pa-0 pr-3 text-capitalize"
              small
              text
              target="_blank"
              href="https://twitter.com/neconotech"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1"
              />
              開発者Twitter
            </v-btn>
          </div>
          <div
            class="pa-0 ma-0"
            style="font-size: 13px"
          >
            powerd by ねこのてっく　Copyright©necono-tech.All rights reserved.
          </div>
        </div>
        <v-spacer />
        <v-btn text     @click="copyUser()">
        <div
          v-if="firebaseUser"
          class="mr-3"


          style="font-size: 12px;"
        >
          ログイン中のユーザー： <v-icon
            color="white"
            size="15px"
          >
            {{
              userProvider == "google.com" ? 'mdi-google' :
              userProvider == "apple.com" ? 'mdi-apple' :
              'mdi-twitter'
            }}
          </v-icon>
          　{{ firebaseUser }}
        </div>
        </v-btn>
        <a
          href="https://apps.apple.com/jp/app/novewrite/id1524194701"
          target="_blank"
        >
          <img
            class="mr-4"
            contain
            height="40px"
            src="../assets/appstore.png"
          >
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.neconotech.novewrite&hl=ja"
          target="_blank"
        >
          <img
            class="mr-4"
            contain
            height="40px"
            src="../assets/googleplay.png"
          ></a>
      </v-card-actions>
    </v-card>
    <v-snackbar
        v-model="snackbar"
        timeout="3000"
    >ユーザーIDをクリップボードにコピーしました</v-snackbar>
  </v-footer>

</template>

<script>
import ListIcon from "@/component/svg/ListIcon";
import {mapState} from "vuex";
import firebase from "firebase";
import user from "../store/modules/user";

export default {
  name: "Footer",
  components: {
    ListIcon
  },
  methods: {
    isHide() {
      return this.$route.path.startsWith("/novels/") && this.hideAppbar
    },
   async copyUser(){
     const userId = firebase.auth().currentUser?.uid
     await navigator.clipboard.writeText(userId)
    this.snackbar=true
    }
  },
  computed: {
    ...mapState({
      hideAppbar: state => state.userModule.hideTopBottomMode
    })
  },
  data() {
    return {
      accentColor: null,
      subPrimaryColor: null,
      firebaseUser: firebase.auth().currentUser.displayName ? firebase.auth().currentUser.displayName : firebase.auth().currentUser.providerData[0].email,
      userProvider: firebase.auth().currentUser.providerData[0].providerId,
      snackbar:false
    }
  },
  watch: {
    '$vuetify.theme.themes.light.secondary'(old, newValue) {
      this.accentColor = this.$vuetify.theme.themes.light.secondary
      const primary = this.$vuetify.theme.themes.light.primary
      const red = parseInt(primary.substring(1, 3), 16);
      const green = parseInt(primary.substring(3, 5), 16);
      const blue = parseInt(primary.substring(5, 7), 16);
      this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    const primary = this.$vuetify.theme.themes.light.primary
    const red = parseInt(primary.substring(1, 3), 16);
    const green = parseInt(primary.substring(3, 5), 16);
    const blue = parseInt(primary.substring(5, 7), 16);

    this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)

  }
}
</script>

<style scoped>

</style>